var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.translatedSortModes.length
    ? _c(
        "a-popover",
        {
          key: "contact-sorder",
          attrs: {
            visible: _vm.sortModePopupVisible,
            overlayClassName: "filterMenu no-padding",
            placement: "bottom",
            trigger: "click",
          },
          on: {
            visibleChange: function (isVisible) {
              return (_vm.sortModePopupVisible = isVisible)
            },
          },
        },
        [
          _c("div", { attrs: { slot: "content" }, slot: "content" }, [
            _c("div", { staticClass: "sort-list-wrapper filter-list-bg" }, [
              _c(
                "div",
                { staticClass: "custom-list" },
                _vm._l(_vm.translatedSortModes, function (filter) {
                  return _c(
                    "div",
                    {
                      key: filter.key,
                      staticClass: "custom-list-item",
                      on: {
                        click: function () {
                          return _vm.changeSortMode(filter.key)
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "material-icons" }, [
                        _vm._v(_vm._s(filter.materialIcon || "sort")),
                      ]),
                      _vm._v(
                        "\n                    " +
                          _vm._s(filter.label) +
                          "\n                "
                      ),
                    ]
                  )
                }),
                0
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "add-sort-button" }, [
            _c("span", { staticClass: "material-icons" }, [
              _vm._v(" swap_vert "),
            ]),
            _vm._v(" "),
            _vm.contactListSortMode
              ? _c("div", { staticClass: "add-button-text" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("chatWindow.sortBy")) +
                      " : " +
                      _vm._s(_vm.getSortLabel(_vm.contactListSortMode)) +
                      "\n        "
                  ),
                ])
              : _c("div", { staticClass: "add-button-text" }, [
                  _vm._v(_vm._s(_vm.$t("chatWindow.selectFilter"))),
                ]),
            _vm._v(" "),
            _c("span", { staticClass: "material-icons" }, [
              _vm._v(" arrow_drop_down "),
            ]),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }